import React from 'react';
import {Route} from 'react-router';
import AsyncPage from './async';

export default [
  <Route
    key="/business/ai-statement"
    exact
    path="/business/ai-statement"
    component={AsyncPage}
  />,
];
